import config from "./config";
import apiService from "./apiService";
export default {
  async getLiablityInformation(clientId) {
    let liablityApiUrl = `${config.liablityApiUrl}/${clientId}`;
    return apiService.get(liablityApiUrl);
  },
  async saveLoanInformation(loanModel, iceModel) {
    let payload = {
      liabilityDTO: loanModel,
      projectionResult: iceModel,
    };
    let saveliablityApiUrl = `${config.saveLoanApiUrl}`;
    return apiService.post(saveliablityApiUrl, payload);
  },
  async saveAsLoanInformation(loanModel, iceModel) {
    let payload = {
      liabilityDTO: loanModel,
      projectionResult: iceModel,
    };
    let saveliablityApiUrl = `${config.saveAsLoanApiUrl}`;
    return apiService.post(saveliablityApiUrl, payload);
  },

  async getIceLoanInformation(apiModel, fileName = "") {
    let iceLoanData = `${config.iceLoanApiUrl}/${fileName}`;
    return apiService.post(iceLoanData, apiModel);
  },

  async createCopyOfLoan(apiModel) {
    let iceLoanData = `${config.copyLoanApiUrl}`;
    return apiService.post(iceLoanData, apiModel);
  },

  async deleteLoan(loanid,encClientId) {
    let iceLoanData = `${config.deleteLoanApiUrl}/${loanid}/${encClientId}`;
    return apiService.delete(iceLoanData);
  },
  async updateLoan(loan) {
    let iceLoanData = `${config.liablityApiUrl}`;
    return apiService.put(iceLoanData, loan);
  },
};
